export default "__VITE_ASSET__BBsBJUj6__"